import type {HouseholdAssignedTo} from "../types";

export function getHouseholdAssignedTo(
  raw: HouseholdAssignedTo | null | undefined,
): HouseholdAssignedTo | null {
  if (raw == null) return null;
  if (typeof raw.id !== "number" || !raw.name) return null;
  return raw;
}
